import _objectSpread from "F:/Lee/Desktop/0206/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import request from './request'; // 首页  提交并获取方案

export var cusProgramadd = function cusProgramadd(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'cusProgramadd'
    })
  });
}; // 新闻咨询和行业动态

export var getnewslist = function getnewslist(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getnewslist'
    })
  });
}; // 新闻咨询详情和行业动态详情

export var getnewsinfo = function getnewsinfo(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getnewsinfo'
    })
  });
}; // 案例

export var getcaselist = function getcaselist(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getcaselist'
    })
  });
}; // 案例详情

export var getcaseinfo = function getcaseinfo(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getcaseinfo'
    })
  });
}; // 最底部内容

export var getsysset = function getsysset(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getsysset'
    })
  });
}; // 硬件产品

export var getproductcatelist = function getproductcatelist(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getproductcatelist'
    })
  });
}; // 合作加盟里获取方案

export var contract_temp = function contract_temp(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'contract_temp'
    })
  });
}; // 产品操作手册

export var getproductfilelist = function getproductfilelist(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getproductfilelist'
    })
  });
}; // 系列产品外链

export var getProductSeries = function getProductSeries(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getProductSeries'
    })
  });
}; // 获取方案列表

export var get_contract_temp = function get_contract_temp(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'get_contract_temp'
    })
  });
}; // 查询授权

export var get_grant = function get_grant(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'get_grant'
    })
  });
}; // 查询授权

export var getproductlist = function getproductlist(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getproductlist'
    })
  });
}; // 硬件产品详情

export var getproductinfo = function getproductinfo(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getproductinfo'
    })
  });
}; // 客服二维码

export var get_customer_service = function get_customer_service(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'get_customer_service'
    })
  });
}; // 提交证据或者举报盗版

export var add_grant_information = function add_grant_information(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'add_grant_information'
    })
  });
}; // 轮播图

export var getbanner = function getbanner(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getbanner'
    })
  });
}; // 获取最新更新详情

export var getproductfileinfo = function getproductfileinfo(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getproductfileinfo'
    })
  });
}; // 首页专用最新更新

export var getproductfilenewestlist = function getproductfilenewestlist(data) {
  return request({
    url: '/api/api',
    method: 'POST',
    data: _objectSpread(_objectSpread({}, data), {}, {
      method: 'getproductfilenewestlist'
    })
  });
};